import { appRoute } from "routes/appRoute";
import { Button, Modal, Spin } from "antd";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React, { memo, useCallback, useEffect, useMemo } from "react";
import {
  cancelDatabaseBackupPopup,
  createDatabaseBackup,
  openDatabaseBackupPopup,
  setIsShowDatabaseBackupModal
} from "redux/reducers/common.slice";

const DatabaseBackupModal = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const theme = localStorage.getItem("default-theme");
  const { isShowDatabaseBackupModal, isDatabaseBackupLoading } = useSelector(
    ({ common }) => common
  );

  const showOnRoutes = useMemo(() => {
    if (location.pathname === "/user-select-location") return false;

    return appRoute?.some(
      (item) => item?.isPublic === false && item?.path === location?.pathname
    );
  }, [location.pathname]);

  const setModalView = useCallback(
    (data = false) => dispatch(setIsShowDatabaseBackupModal(data)),
    [dispatch]
  );

  useEffect(() => {
    if (showOnRoutes) {
      dispatch(openDatabaseBackupPopup())
        .then((res) => {
          setModalView(res?.payload);
        })
        .catch(() => {
          setModalView(false);
        });
    }
  }, [dispatch, location, setModalView, showOnRoutes]);

  const handleClose = () => {
    dispatch(cancelDatabaseBackupPopup());
    setModalView(false);
  };

  const handleSubmit = () => {
    dispatch(createDatabaseBackup());
    setModalView(false);
  };

  return (
    <>
      {isDatabaseBackupLoading && (
        <Spin tip="Loading" size="large">
          <div className="content" />
        </Spin>
      )}
      <Modal
        centered
        open={isShowDatabaseBackupModal}
        title="Do You Want Database Backup?"
        className={`reminderModal theme-${theme}`}
        maskClosable={false}
      >
        <div className="d-flex justify-content-center gap-2">
          <Button className="btn_primary reminder_btn" onClick={handleSubmit}>
            Yes
          </Button>

          <Button className="btn_gray close_btn" onClick={handleClose}>
            Cancel
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default memo(DatabaseBackupModal);
